module.exports = {
      id: "spiritual-usage",
      viewBox: "0 0 27.233 28.49",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#spiritual",
      toString: function () {
        return this.url;
      }
    }